export default "__VITE_ASSET__B8MqYe79__"